import { render, staticRenderFns } from "./errorRecord.vue?vue&type=template&id=baccc102&scoped=true"
import script from "./errorRecord.vue?vue&type=script&lang=js"
export * from "./errorRecord.vue?vue&type=script&lang=js"
import style0 from "./errorRecord.vue?vue&type=style&index=0&id=baccc102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baccc102",
  null
  
)

export default component.exports